module.exports = __webpack_public_path__ + "static/media/githubIcon.f03dc19e.svg";